'use strict';

var RecommendationDetailsPanelDirective = function RecommendationDetailsPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'RecommendationDetailsPanelController',
    template: require('../templates/recommendation-details-panel.html'),
    scope: {
      screenState: '=',
      dataDimension: '=dimension'
    }
  };
};
RecommendationDetailsPanelDirective.$inject = [];
module.exports = RecommendationDetailsPanelDirective;